export enum ProductType {
  Receiver = 'receiver',
  Premium = 'premium',
  Subscription = 'subscription',
  Equipment = 'equipment',
  Installation = 'installation',
  Shipping = 'shipping',
  Multiroom = 'multiroom',
  Internet = 'internet',
}
